import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useDidMount from "../../../hooks/useDidMount";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import {CustomIconRef} from "../../../components/CustomIcon";
import PermissionsSelect from "./PermissionsSelect";
import {
  setManageFeatureModals,
  tryUpdateFeaturesPermissions
} from "../../../redux/slices/permissionSlice";
import {PERMISSION_LIST_MAPPER} from "../constants";


export default function AddPermissionsModal() {

  const {modal, data: feature} = useSelector((state => state.permission.modals.permission));
  const dispatch = useDispatch();
  const [newPermissions, setNewPermissions] = useState([]);

  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);

  const submitForm = () => {
    dispatch(tryUpdateFeaturesPermissions({
      permissions: newPermissions

    }));
  };

  useDidMount(() => {
    if (modal) {
      setNewPermissions(feature.permissions ?? []);
    } else {
      setNewPermissions([]);
    }
  }, [modal]);

  const onPermissionSelect = (permission, append = false) => {
    setNewPermissions(append ? [...newPermissions, permission] : permission);
  };

  const onPermissionRemove = (permission) => {
    setNewPermissions(newPermissions.filter((p) => p.id !== permission.id));
  };
  return (
    <CustomModal title="Permissions"
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageFeatureModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing}
                                       onClick={submitForm}>Confirm</CustomButton>}>
                                        <div className="text-lg font-semibold mb-6">Manage the permissions for the {feature?.name}. </div>
      <div className="flex flex-col">
        <div className="flex items-end">
          {!!modal &&
            <PermissionsSelect disabled={editing} exclude={newPermissions} onPermissionSelect={onPermissionSelect}/>
          }
          <PermissionActions disabled={editing} className="ml-2 mb-3" setNewPermissions={onPermissionSelect}/>

        </div>

        <ChipGroup>
          {
            newPermissions.map((f) => <ChipSecondary disabled={editing} label={f.name} key={f.id}
                                                     onClose={() => onPermissionRemove(f)}/>)
          }

        </ChipGroup>
      </div>
    </CustomModal>
  );
}

const PermissionActions = ({className = "", setNewPermissions, disabled = false}) => {

  const {init, data} = useSelector((state => state.permission.permissions));

  const setPharmacistAdminFeatures = (feat) => {
    setNewPermissions(getMappedPermissions(feat, data));
  };


  return (
    <div className={className}>
      <DropdownMenu
        trigger={({triggerRef, isSelected, testId, ...props}) => (
          <CustomIconRef ref={triggerRef} size="2xl" className="p-3 text-black cursor-pointer" {...props}
                         icon="more_vert"/>
        )}
      >
        <DropdownItemGroup>
          <DropdownItem isDisabled={disabled} onClick={() => setNewPermissions([])}>Revoke All</DropdownItem>
          {
            Object.keys(PERMISSION_LIST_MAPPER).map((pl) => <DropdownItem isDisabled={disabled || !init} key={pl}
                                                                          onClick={() => setPharmacistAdminFeatures(pl)}>{pl}</DropdownItem>)
          }

        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};

const getMappedPermissions = (feat, permissions) => permissions.filter((p) => (PERMISSION_LIST_MAPPER[feat] ?? []).some((op) => op === p.name));



